import {Action, AlertProps, BreadcrumbType} from 'platform/components';

export type SettingsTemplateHeader = {
  title?: string;
  subtitle?: string;
  breadcrumbs?: BreadcrumbType[];
  actions?: Action[];
  alerts?: AlertProps[];
};
